<template>
    <div>
        <div class="w-full px-4 py-3 text-sm border-2 border-slate-700 rounded uppercase my-1">
            <div class="grid grid-cols-3">
                <div class="col-span-2">
                    {{ track.track }} <br>
                    <small class="text-slate-500 text-xs">{{ (track.size / 1000000).toFixed(2) + ' MB' }}</small>
                </div>
                <div class="flex justify-center items-center gap-x-7 ">
                    <div @click="playTrack" v-if="!audioPlayed" class="hover:cursor-pointer">
                        <i class="fa-solid fa-play"></i>
                    </div>
                    <div @click="pauseTrack" v-if="audioPlayed" class="hover:cursor-pointer">
                        <i class="fa-solid fa-pause"></i>
                    </div>
                    <div @click="downloadAudio(track)" class="hover:cursor-pointer p-3">
                        <i class="fa-solid fa-download"></i>
                    </div>
                </div>

                <audio ref="audioElement" :src="track.audio_file"></audio>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'

let emits = defineEmits(['downloading'])
defineProps(['track'])

let audioPlayed = ref(false)
const audioElement = ref(null);
const downloadBaseUrl = process.env.VUE_APP_FILE_DOWNLOAD_URL;

function playTrack() {
    audioPlayed.value = true
    audioElement.value.play()
}
function pauseTrack() {
    audioPlayed.value = false
    audioElement.value.pause()
}

function downloadAudio(audioURL) {
  const decodedPath = decodeURIComponent(
    audioURL.audio_file.split('/o/')[1].split('?')[0]
  );

  const filePath = encodeURIComponent(decodedPath);
  const baseUrl = downloadBaseUrl;

  window.location.href = `${baseUrl}?path=${filePath}`;

  emits('downloading', { name: audioURL.track, msg: 'Download is starting' })
}
</script>

<style scoped>

</style>